import { Customization } from '@eduvision/toolkit';


export const accounts: Customization['accounts'] = {
  // hideTerms: true
};
